import { DigestJobResult } from '@vision/ui/interfaces';
import { createContext, useContext } from 'react';

interface JobResultsContextType {
  jobResults: DigestJobResult[] | null;
}

const JobResultsContext = createContext<JobResultsContextType>({
  jobResults: null,
});

export const useJobResults = () => {
  const context = useContext(JobResultsContext);
  return context.jobResults;
};

export const JobResultsProvider = JobResultsContext.Provider;
